import apiService from './api';
import { IBuilding } from 'src/models/interfaces/building';

export class BuildingService {
  public get(): Promise<{ data: IBuilding[] }> {
    return apiService.get('/building');
  }

  public getCountry(): Promise<{ data: string[] }> {
    return apiService.get('/building/country');
  }

  public getState(country: string): Promise<{ data: string[] }> {
    return apiService.get(`/building/state/country/${country}`);
  }

  public getCity(state: string): Promise<{ data: string[] }> {
    return apiService.get(`/building/city/state/${state}`);
  }
}

const buildingService = new BuildingService();
export default buildingService;